import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OERIAPIConstant } from '../constants/oeri.constant';
import { AppConfigService } from './base/app-config.service';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class OERIService {
  apiBaseUrl = `${AppConfigService.settings.apiUrl}`;
  
  getCurrentFacilityId(): string {
    return localStorage.getItem('current_facility_id') || 'ES';
  }

  constructor(private http: HttpClient,private rest: RestService) {
  }

  getOeriStatistics() {
    const facilityId = this.getCurrentFacilityId();
    return (
      this.http.get<any>(`${this.apiBaseUrl}${OERIAPIConstant.GetOERIStatistics}?facilityId=${facilityId}`) )
  }

  getOeriData() {
    const facilityId = this.getCurrentFacilityId();
    return (
      this.http.get<any>(`${this.apiBaseUrl}${OERIAPIConstant.getOeriReport}?facilityId=${facilityId}`) )
  }

  getOeriDataExcel() {
    const facilityId = this.getCurrentFacilityId();
      return this.rest.download(`${OERIAPIConstant.GetMatchOERIOpenTLRReportExcel}?facilityId=${facilityId}`,"",{ responseType: 'blob' });

  }

  getDiscoveredPastReports(filters: any) {
    const facilityId = this.getCurrentFacilityId();
    return (
      this.http.get<any>(`${this.apiBaseUrl}${OERIAPIConstant.GETOERIDISPAST60DAYSREPORT}?facilityId=${facilityId}&divisionName=${filters.division}&sectionName=${filters.section}&plantName=${filters.plant}`, filters) )
  }

  getDiscoveredPastReportsExcel(filters: any) {
    const facilityId = this.getCurrentFacilityId();
      return this.rest.download(`${OERIAPIConstant.GETOERIDISPAST60DAYSREPORTEXCEL}?facilityId=${facilityId}&divisionName=${filters.division}&sectionName=${filters.section}&plantName=${filters.plant}`,"",{ responseType: 'blob' });

  }
  getOrphanReports(filters: any) {
    const facilityId = this.getCurrentFacilityId();
    return (
      this.http.get<any>(`${this.apiBaseUrl}${OERIAPIConstant.GetOERIOrphanedTLRReport}?facilityId=${facilityId}&divisionName=${filters.division}&sectionName=${filters.section}&plantName=${filters.plant}`, filters) )
  }

  getOrphanReportsExcel(filters: any) {
    const facilityId = this.getCurrentFacilityId();
      return this.rest.download(`${OERIAPIConstant.GetOERIOrphanedTLRReportExcel}?facilityId=${facilityId}&divisionName=${filters.division}&sectionName=${filters.section}&plantName=${filters.plant}`,"",{ responseType: 'blob' });

  }

  getTlrOverdueData(filters: any) {
    const facilityId = this.getCurrentFacilityId();
    return (
      this.http.get<any>(`${this.apiBaseUrl}${OERIAPIConstant.GetOverdueTLRDetailsReport}?facilityId=${facilityId}&divisionName=${filters.division}&sectionName=${filters.section}&plantName=${filters.plant}`, filters) )
  }

  getTlrOverdueDataExcel(filters: any) {
    const facilityId = this.getCurrentFacilityId();
      return this.rest.download(`${OERIAPIConstant.GetOverdueTLRDetailsReportExcel}?facilityId=${facilityId}&divisionName=${filters.division}&sectionName=${filters.section}&plantName=${filters.plant}`,"",{ responseType: 'blob' });

  }
}